import { render, staticRenderFns } from "./page-cdm.vue?vue&type=template&id=4874a94c&scoped=true&"
import script from "./page-cdm.vue?vue&type=script&lang=js&"
export * from "./page-cdm.vue?vue&type=script&lang=js&"
import style0 from "./page-cdm.vue?vue&type=style&index=0&id=4874a94c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874a94c",
  null
  
)

export default component.exports